import networkBg from 'assets/images/socialNetworks/network-modal-bg.jpg';
import networkCharacter from 'assets/images/socialNetworks/network-modal-character.png';
import { ReactComponent as TgIcon } from 'assets/images/socialNetworks/telegram-icon.svg';
import { ReactComponent as WaIcon } from 'assets/images/socialNetworks/whats-app-icon.svg';
import { TELEGRAM_URL, WHATSAPP_URL } from 'components/general/Footer';
import { ImageComponent } from 'components/Image';
import { Logo } from 'components/Logo';
import type { ModalDefaultProps } from 'components/Modal';
import { ModalTemplate } from 'components/ModalTemplate';
import type { ModalTemplateSettings } from 'components/ModalTemplate/types';
import { useTheme } from 'hooks/theme';
import { useMedia } from 'modules/common/hooks/useMedia';
import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-navi';
import { ScNetworks } from './styled';

export const Network = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const {
      t,
      i18n: { language },
    } = useTranslation('common');

    const { images } = useTheme();

    const { isMobileS } = useMedia();

    const modalSettings: ModalTemplateSettings = useMemo(
      () =>
        isMobileS
          ? {
              type: 'mobile',
              mode: {
                type: 'background-custom',
                src: networkBg,
                position: 'left top',
              },
            }
          : {
              type: 'desktop',
              size: 'large',
              mode: {
                type: 'background-custom',
                src: networkBg,
                position: 'right top',
              },
            },
      [isMobileS]
    );

    return (
      <ModalTemplate onClose={onClose} ref={ref} settings={modalSettings}>
        <ScNetworks>
          <div className={`content ${language.toLowerCase()}`}>
            <Logo height={28} />

            <div className="description">{t('socialNetworks.modalText')}</div>

            <div className="networks">
              <div>
                <Link href={TELEGRAM_URL} target={'_blank'}>
                  <TgIcon />
                  <span>{t('socialNetworks.followOnTelegram')}</span>
                  <images.arrowLeftIcon.component />
                </Link>
              </div>
              <div>
                <Link href={WHATSAPP_URL} target={'_blank'}>
                  <WaIcon />
                  <span>{t('socialNetworks.followOnWhatsApp')}</span>
                  <images.arrowLeftIcon.component />
                </Link>
              </div>
            </div>
          </div>

          <ImageComponent
            alt="character"
            className="character"
            height={280}
            src={networkCharacter}
            width={280}
          />
        </ScNetworks>
      </ModalTemplate>
    );
  }
);

export default Network;
